import { render, staticRenderFns } from "./SceneMatter.vue?vue&type=template&id=36805d8e&"
import script from "./SceneMatter.vue?vue&type=script&lang=js&"
export * from "./SceneMatter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports